import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getApiLog} from '../../../apis/user/getApiLog'

const PAGE_SIZE = 10

const useQueryApiLog = (currentPage: number = 1, exchange = '') => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getApiLog(currentPage, exchange),
        queryFn: async () => {
            const {data, pageInfo} = await getApiLog(PAGE_SIZE, currentPage, exchange)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryApiLog
